import React from "react";
import CustomCheckbox from "../../Components/CustomCheckBox";
import {DownArrowIcon} from "../../Components/Icons";
import {withButtonLoader} from "../../helpers";

const ECheckManualEntry = ({
    paymentType,
    payerUser,
    accountType,
    handleInputChange,
    handleSubmit,
    isPaymentSaveDetails,
    setIsPaymentSaveDetails,
    isDefault,
    setIsDefault,
    transactionLoading
}) => {
    return (
        <div
            className={`tab-pane ${paymentType === "eCheck" ? "fade show active" : ""}`}
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
        >
            <div className="sos-content payment-inner-toggleable">
                <form onSubmit={(e) => {
                    console.dir('payerUser #sdlkfjsldkfj')
                    console.dir(payerUser)
                    handleSubmit(e)
                }}>
                    <div className="dropdown custom-dropdown mb-3">
                        <select
                            name="accountType"
                            className="form-control custom-input-border-css"
                            required
                            onChange={(e) => handleInputChange(e)}
                        >
                            <option value="">Account Type</option>
                            <option value="0">Personal</option>
                            <option value="1">Business</option>
                        </select>
                        <div className="down-arrow">
                            <DownArrowIcon/>
                        </div>
                    </div>
                    {accountType == "0" ? (<div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputBankName1"
                            className="form-label payment-form-label"
                        >
                            Name On Account
                        </label>
                        <div className="row g-2">
                            <div className="col-md">
                                <div
                                    className="payment-controlpanl-style">
                                    <input
                                        type="text"
                                        name="accountFirstName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="First Name"
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div>
                                    <input
                                        type="text"
                                        name="accountLastName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="Last Name"
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>) : (<div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputBankName1"
                            className="form-label payment-form-label"
                        >
                            Name On Account
                        </label>
                        <input
                            type="text"
                            name="companyName"
                            required
                            className="form-control custom-input-border-css"
                            id="exampleInputName1"
                            aria-describedby="nameHelp"
                            placeholder="Enter Name on the Account"
                        />
                    </div>)}

                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputEmail1"
                            className="form-label payment-form-label"
                        >
                            Bank Name
                        </label>
                        <input
                            type="text"
                            className="form-control custom-input-border-css"
                            id="exampleInputBankName"
                            placeholder="Enter Bank Name"
                            aria-describedby="bankNameHelp"
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputPassword1"
                            className="form-label payment-form-label"
                        >
                            Bank Routing Number
                        </label>
                        <input
                            type="text"
                            id="exampleInputBankNumber1"
                            name="bankRoutingNumber"
                            className="form-control custom-input-border-css"
                            placeholder="Enter Bank Routing Number"
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputPassword1"
                            className="form-label payment-form-label"
                        >
                            Bank Account Number
                        </label>
                        <input
                            type="text"
                            name="bankAccountNumber"
                            className="form-control custom-input-border-css"
                            id="exampleInputAccountNumber1"
                            placeholder="Enter Bank Account Number"
                            required
                        />
                    </div>

                    <div className="checkbox-list mt-3">
                        <label
                            className="label-check font-weight-light float-end">
                            <CustomCheckbox
                                name="isPaymentSaveDetails"
                                checked={isPaymentSaveDetails}
                                onChange={(e) => setIsPaymentSaveDetails(!isPaymentSaveDetails)}
                            />
                            <span>
                                Save these payment details for future payments
                            </span>
                        </label>
                        <div className="payment-checbox">
                            <label
                                className="font-weight-light label-check ml-xl-5">
                                <CustomCheckbox
                                    name="isDefault"
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(!isDefault)}
                                />
                                Set as default payment method
                            </label>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center">
                        <button
                            type="submit"
                            className="sos-mack-btn sos-custom-btn-css"
                            disabled={transactionLoading}
                        >
                            {withButtonLoader("Make a Payment", transactionLoading)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ECheckManualEntry;